import React from 'react';
import T from 'prop-types';

import useShowMiniHeader from '../hooks/useShowMiniHeader';

const AppInsightsSrollable = ({ children }) => {
  const scrollRef = useShowMiniHeader();

  return (
    <div ref={scrollRef} className="app-insights-srollable-wrapper">
      {children}
    </div>
  );
};

AppInsightsSrollable.propTypes = {
  children: T.node.isRequired,
};

export default AppInsightsSrollable;
